module.exports = __webpack_public_path__ + "static/media/item_33_8.739f93b0.png";